import { connect } from 'react-redux';
import { useEffect, useState } from 'react';
import { Box, Button, Grid, IconButton, Typography } from '@mui/material';
import api_service from '../../network/api_callbacks';
import _, { set } from "lodash";
import { generatePublicUrlForFileInAWSS3Bucket } from '../../services/uploadFileOnAWS_S3_Bucket';
import { Add, Remove, CloseRounded, EditRounded, UpdateRounded } from '@mui/icons-material';
import EntityStatsHistory from '../../components/StatsManagement/EntityStatsHistory';
import SubmitStatsDialog from '../../components/StatsManagement/SubmitStatsDialog';
import ViewStatsDialog from '../../components/GameManagement/FantasyGame/ViewStatsDialog';

function FantasyLeagueGameActiveStats({ userData, props }) {

    const [activeStatsList, setActiveStatsList] = useState([]);
    const [statsList, setStatsList] = useState([]);
    const [isEntityStatsHistoryDialogOpen, setIsEntityStatsHistoryDialogOpen] = useState(false);
    const [isSubmitStatsDialogOpen, setIsSubmitStatsDialogOpen] = useState(false);
    const [selectedEntityStats, setSelectedEntityStats] = useState(null);
    const [selectedEntityGroup, setSelectedEntityGroup] = useState(null);

    useEffect(() => {
        if (activeStatsList?.length === 0) {
            getActiveStats();
        }
        // if (statsList?.length === 0) {
        //     getStats();
        // }
        return () => {
            setActiveStatsList([]);
            //setStatsList([]);
            setSelectedEntityStats(null);
            setSelectedEntityGroup(null);
        }
    }, []);

    const getActiveStats = async () => {
        try {
            const response = await api_service.getActiveStatsEntity();
            console.log('📘 getActiveStats Data:', response);
            if (response?.length > 0) {
                const transformed = response.reduce((acc, group) => {
                    acc[group?.type] = group?.entity?.map((item) => ({
                        entId: item?._id,
                        entityDetail: item, // keep full entity
                        dates: [], // empty initially, can be filled later
                    }));
                    return acc;
                }, {});

                setStatsList(transformed);
                console.log("Grouping by groupedEntities:", transformed);
            }

        } catch (error) {
            console.error('❌ Failed to fetch getActiveStats:', error);
        }
    }

    const getStats = async () => {
        try {
            const response = await api_service.getStats();
            console.log('📘 getStats Data:', response);
            if (response?.length > 0) {
                const groupedEntities = _.groupBy(response, (item) => {
                    const groupedEnt = item?.entityDetail?.type;
                    console.log("Grouping by type:", groupedEnt);
                    return groupedEnt;
                });
                setStatsList(groupedEntities || []);
                console.log("Grouping by groupedEntities:", groupedEntities);
            }
        } catch (error) {
            console.error('❌ Failed to fetch getActiveStats:', error);
        }
    }

    return (
        <div style={styles.container}>
            <>
                <Box sx={{ flex: 1, height: "100%", padding: 0, marginTop: 2 }}>

                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 4,
                            mt: 5
                        }}>
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 0,
                            px: 2
                        }}>

                        </Box>

                        {/* Create */}
                        <Box sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            mb: 0,
                            px: 2
                        }}>
                            <Button
                                variant="contained"
                                color="success"
                                sx={{ borderRadius: 2, textTransform: "none", px: 4 }}
                                onClick={() => {
                                    //console.log("create button clicked!! : ")
                                    //console.log("statsList : ", statsList);
                                    createEntityCsv(statsList);
                                }}
                            >
                                Export Active Stats CSV
                            </Button>
                        </Box>
                    </Box>

                    {<Box sx={{ p: 0 }}>

                        {/* Use With getStats */}
                        {/* {Object.keys(statsList).map((typeKey) => (
                            <Box key={typeKey} style={{ border: "1px solid #ccc", borderRadius: 4, padding: 16, backgroundColor: '#fcfcfcff' }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        mb: 1,
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        sx={{ textAlign: "left" }}
                                    >
                                        {typeKey.charAt(0).toUpperCase() + typeKey.slice(1)}s
                                    </Typography>

                                    <IconButton
                                        onClick={() => {
                                            setIsSubmitStatsDialogOpen(true);
                                            setSelectedEntityGroup({typeKey, stats: statsList[typeKey]})
                                        }}
                                        size="small"
                                        sx={{ p: 0.5 }}
                                    >
                                        <EditRounded fontSize="medium" />
                                    </IconButton>
                                </Box>

                                <Grid container spacing={2}>
                                    {statsList[typeKey].map((option, idx) => (
                                        <Grid item key={option?.entId || idx}>
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    height: 140,
                                                    width: 240,
                                                    borderRadius: 2,
                                                    overflow: "hidden",
                                                    backgroundColor: "whitesmoke",
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    p: 1,
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 80,
                                                        height: 80,
                                                        borderRadius: 2,
                                                        overflow: "hidden",
                                                        backgroundImage: `url(${generatePublicUrlForFileInAWSS3Bucket(option?.entityDetail?.image) || "https://d3oxgt44kg2k0d.cloudfront.net/private/ap-south-1%3A64038f50-13d3-cf2a-9102-fab5a61c8c2e/banners/Screenshot%202025-04-23%20114159.png"})`,
                                                        backgroundSize: "cover",
                                                        backgroundPosition: "center",
                                                        mr: 2,
                                                        flexShrink: 0,
                                                    }}
                                                />

                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                                                        {option?.entityDetail?.displayName}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {option?.entityDetail?.type}
                                                    </Typography>
                                                </Box>

                                                {option?.dates?.length > 0 && <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 4,
                                                        right: 4,
                                                    }}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setSelectedEntityStats(option);
                                                            setIsEntityStatsHistoryDialogOpen(true);
                                                        }}
                                                        size="small"
                                                        sx={{ p: 0.5 }}>
                                                        <UpdateRounded fontSize="small" />
                                                    </IconButton>
                                                </Box>}
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        ))} */}

                        {Object.keys(statsList).map((typeKey) => (
                            <Box key={typeKey} style={{ border: "1px solid #ccc", borderRadius: 4, padding: 16, backgroundColor: '#fcfcfcff', marginBottom: 4 }}>
                                <Box
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        mb: 1,
                                    }}
                                >
                                    <Typography
                                        variant="subtitle1"
                                        fontWeight={600}
                                        sx={{ textAlign: "left" }}
                                    >
                                        {typeKey.charAt(0).toUpperCase() + typeKey.slice(1)}s
                                    </Typography>

                                    <IconButton
                                        onClick={() => {
                                            setIsSubmitStatsDialogOpen(true);
                                            setSelectedEntityGroup({ typeKey, stats: statsList[typeKey] })
                                        }}
                                        size="small"
                                        sx={{ p: 0.5 }}
                                    >
                                        <EditRounded fontSize="medium" />
                                    </IconButton>
                                </Box>

                                <Grid container spacing={2}>
                                    {statsList[typeKey].map((option, idx) => (
                                        <Grid item key={option?.entId || idx}>
                                            <Box
                                                sx={{
                                                    position: "relative",
                                                    height: 140,
                                                    width: 240,
                                                    borderRadius: 2,
                                                    overflow: "hidden",
                                                    backgroundColor: "whitesmoke",
                                                    backgroundSize: "cover",
                                                    backgroundPosition: "center",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    p: 1,
                                                    border: "1px solid #ccc",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        width: 80,
                                                        height: 80,
                                                        borderRadius: 2,
                                                        overflow: "hidden",
                                                        backgroundImage: `url(${generatePublicUrlForFileInAWSS3Bucket(option?.entityDetail?.image) || ""})`,
                                                        backgroundSize: "cover",
                                                        backgroundPosition: "center",
                                                        mr: 2,
                                                        flexShrink: 0,
                                                    }}
                                                />

                                                <Box sx={{ flexGrow: 1 }}>
                                                    <Typography fontWeight="bold" sx={{ fontSize: 12 }}>
                                                        {option?.entityDetail?.displayName}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary">
                                                        {option?.entityDetail?.type}
                                                    </Typography>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 4,
                                                        right: 4,
                                                    }}>
                                                    <IconButton
                                                        onClick={() => {
                                                            console.log("option : ", option)
                                                            setSelectedEntityStats(option);
                                                            setIsEntityStatsHistoryDialogOpen(true);
                                                        }}
                                                        size="small"
                                                        sx={{ p: 0.5 }}>
                                                        <UpdateRounded fontSize="small" />
                                                    </IconButton>
                                                </Box>

                                                {/* {option?.dates?.length > 0 && <Box
                                                    sx={{
                                                        position: "absolute",
                                                        top: 4,
                                                        right: 4,
                                                    }}>
                                                    <IconButton
                                                        onClick={() => {
                                                            setSelectedEntityStats(option);
                                                            setIsEntityStatsHistoryDialogOpen(true);
                                                        }}
                                                        size="small"
                                                        sx={{ p: 0.5 }}>
                                                        <UpdateRounded fontSize="small" />
                                                    </IconButton>
                                                </Box>} */}
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>
                        ))}
                    </Box>}

                </Box>

                {/* <EntityStatsHistory
                    open={isEntityStatsHistoryDialogOpen}
                    onClose={() => {
                        setIsEntityStatsHistoryDialogOpen(false)
                    }}
                    selectedEntityStats={selectedEntityStats}
                /> */}

                <ViewStatsDialog
                    open={isEntityStatsHistoryDialogOpen}
                    onClose={() => {
                        setIsEntityStatsHistoryDialogOpen(false);
                        setSelectedEntityStats(null);
                    }}
                    entityForViewStats={selectedEntityStats}
                />

                <SubmitStatsDialog
                    open={isSubmitStatsDialogOpen}
                    onClose={() => {
                        setIsSubmitStatsDialogOpen(false)
                        getActiveStats();
                        setSelectedEntityGroup(null);
                        //getStats();
                    }}
                    selectedEntityGroup={selectedEntityGroup}
                />
            </>
        </div>
    );
}

export const createEntityCsv = (data) => {
    // Get current date and time for filename suffix
    const now = new Date();
    const dd = String(now.getDate()).padStart(2, '0');
    const mm = String(now.getMonth() + 1).padStart(2, '0');
    const yyyy = now.getFullYear();
    const hh = String(now.getHours()).padStart(2, '0');
    const min = String(now.getMinutes()).padStart(2, '0');
    const timestamp = `${dd}_${mm}_${yyyy}_${hh}-${min}`;

    // For each category/type, build and download its own CSV
    Object.entries(data).forEach(([category, items]) => {
        const rows = [];

        items.forEach((item) => {
            const type = item?.entityDetail?.type;

            const row = {
                "entityID": item?.entityDetail?._id || "",
                "entityName": item?.entityDetail?.displayName || "",
                "entityCategory": type,
                //"Image URL": item?.entityDetail?.image || "",
                // boxOfficeCollection: "-",
                // streamCount: "-",
                // rank: "-",
                // viewCount: "-",
                // commentCount: "-",
                // shareCount: "-",
                // followerCount: "-",
                // uploadCount: "-",
                // "view/likesCount": "-",
            };

            switch (type) {
                case "movie":
                    row.boxOfficeCollection = -1;
                    break;
                case "song":
                    row.streamCount = -1;
                    row.rank = -1;
                    break;
                case "video":
                    row.viewCount = -1;
                    break;
                case "reel":
                    row.viewCount = -1;
                    row.commentCount = -1;
                    row.shareCount = -1;
                    break;
                case "influencers":
                    row.followerCount = -1;
                    row.uploadCount = -1;
                    row["view/likesCount"] = -1;
                    break;
                case 'power_batter':
                case 'finisher':
                    row.strikeRate = -1;
                    row.runs = -1;
                    break;
                case 'strike_bowler':
                case 'spin_master':
                    row.economy = -1;
                    row.wickets = -1;
                    break;
                case 'x_factor':
                    row.runs = -1;
                    row.wickets = -1;
                    break;
                default:
                    break;
            }

            rows.push(row);
        });

        // Skip empty categories
        if (rows.length === 0) return;


        let columns = [
            "entityID",
            "entityName",
            "entityCategory",
            "boxOfficeCollection",
            "streamCount",
            "rank",
            "viewCount",
            "commentCount",
            "shareCount",
            "followerCount",
            "uploadCount",
            "view/likesCount",
            "strikeRate",
            "runs",
            "economy",
            "wickets"
        ];

        if (rows[0].entityCategory === "movie") {
            // Remove the specified columns for movies
            const removeCols = [
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        } else if (rows[0].entityCategory === "song") {
            const removeCols = [
                "boxOfficeCollection",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        } else if (rows[0].entityCategory === "video") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        } else if (rows[0].entityCategory === "reel") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        } else if (rows[0].entityCategory === "influencers") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "strikeRate",
                "runs",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }
        else if (rows[0].entityCategory === "power_batter") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }
        else if (rows[0].entityCategory === "finisher") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "economy",
                "wickets"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }
        else if (rows[0].entityCategory === "strike_bowler") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }
        else if (rows[0].entityCategory === "spin_master") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "runs"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }
        else if (rows[0].entityCategory === "x_factor") {
            const removeCols = [
                "boxOfficeCollection",
                "streamCount",
                "rank",
                "viewCount",
                "commentCount",
                "shareCount",
                "followerCount",
                "uploadCount",
                "view/likesCount",
                "strikeRate",
                "economy"
            ];
            columns = columns.filter(col => !removeCols.includes(col));
        }

        const csvContent = [
            columns.join(","),
            ...rows.map((row) => columns.map((col) => row[col]).join(",")),
        ].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.href = url;

        const safeCategory = (category || 'unknown').toString().trim().replace(/[^a-z0-9_-]+/gi, '_');
        link.setAttribute("download", `Entities_${safeCategory}_${timestamp}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    });
};

// Simple inline styles
const styles = {
    container: {
        padding: '40px',
        textAlign: 'center',
    },
    title: {
        fontSize: '36px',
        marginBottom: '10px',
    },
};

// mapStateToProps (to access Redux state)
const mapStateToProps = (state) => ({

});

// mapDispatchToProps (to dispatch Redux actions)
const mapDispatchToProps = (dispatch) => ({

});

// connect to Redux
export default connect(mapStateToProps, mapDispatchToProps)(FantasyLeagueGameActiveStats);